var exports = {
  "Qs": "KeyboardModeIntroModal.module__content___R3A1R2",
  "h_": "KeyboardModeIntroModal.module__description___R3A1R2",
  "Xq": "KeyboardModeIntroModal.module__tips___R3A1R2",
  "uN": "KeyboardModeIntroModal.module__tip___R3A1R2",
  "HP": "KeyboardModeIntroModal.module__keys___R3A1R2",
  "eS": "KeyboardModeIntroModal.module__kbd___R3A1R2",
  "me": "KeyboardModeIntroModal.module__separator___R3A1R2",
  "xY": "KeyboardModeIntroModal.module__tipText___R3A1R2",
};

module.exports = exports;
